import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	FormGroup, ControlLabel, InputGroup, FormControl, Col, Button,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { isEqual } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Loader } from '@components/common';

import Actions, { thunks } from '@redux/app';

class ResetPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			enteredEmail : '',
		};
	}

	componentDidMount() {
		const { changeForgotPasswordData } = this.props;
		changeForgotPasswordData();
	}

	shouldComponentUpdate = ({
		email, validation, loading, resetPasswordConfirmed,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.email, email)
			|| !isEqual(lastProps.validation, validation)
			|| !isEqual(lastProps.loading, loading)
			|| !isEqual(lastProps.resetPasswordConfirmed, resetPasswordConfirmed)
		);
	}

	componentWillUnmount() {
		const { changeResetPasswordConfirmed } = this.props;
		changeResetPasswordConfirmed(false);
	}

	emailDataChanged = ({ target : { value } }) => {
		const { changeForgotPasswordData, validation } = this.props;
		changeForgotPasswordData({ email : value });
		this.setState({ enteredEmail : value });
		if (validation === 'error') changeForgotPasswordData({ validation : null });
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') this.submit();
	}

	submit = (event) => {
		const { dispatch } = this.props;
		if (event && event.preventDefault) event.preventDefault();
		dispatch(thunks.forgotPassword());
	}

	render() {
		const { enteredEmail } = this.state;
		const {
			email, validation, loading, resetPasswordConfirmed,
		} = this.props;
		return (
			<div className="position-absolute top-0 flex-center bg-primary width-all height-all">
				<Col md={4}>
					<h1 className="text-center margin-top-0 margin-bottom-30">
						<img
							className="width-80-p width-max-250"
							src="/images/logo.png"
							alt="RollKall Logo"
						/>
					</h1>
					<div className="panel panel-shadow padding-25 margin-bottom-10">
						<h5 className="text-center color-dark margin-bottom-15 margin-top-0">Forgot Password</h5>
						<Choose>
							<When condition={!resetPasswordConfirmed}>
								<FormGroup
									controlId="resetPassword"
									validationState={validation}
								>
									<ControlLabel>Email</ControlLabel>
									<InputGroup bsSize="large">
										<InputGroup.Addon><i className="fa fa-user" /></InputGroup.Addon>
										<FormControl
											type="email"
											name="email"
											value={email}
											onChange={this.emailDataChanged}
											onKeyPress={this.handleKeyPress}
										/>
									</InputGroup>
								</FormGroup>
								<Button
									className="btn btn-block btn-success btn-rounded margin-top-30"
									onClick={this.submit}
								>
									Send Password Reset Email
								</Button>
							</When>
							<Otherwise>
								<p className="text-center color-dark margin-top-20">
									If a matching account is found, an email will be sent to&nbsp;
									{enteredEmail}
									&nbsp;to allow you to reset your password.
								</p>
							</Otherwise>
						</Choose>
					</div>
					<Link
						to="/login"
						className="btn btn-link color-white font-light padding-0"
					>
						Back
					</Link>
				</Col>
				<Loader active={loading} />
			</div>
		);
	}
}

const mapStateToProps = ({
	app : {
		forgotPassword : {
			email,
			validation,
			loading,
		},
		resetPasswordConfirmed,
	},
}) => ({
	email,
	validation,
	loading,
	resetPasswordConfirmed,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	changeForgotPasswordData     : bindActionCreators(Actions, dispatch).changeForgotPasswordData,
	changeResetPasswordConfirmed : bindActionCreators(Actions, dispatch).changeResetPasswordConfirmed,
});

ResetPassword.propTypes = {
	changeForgotPasswordData     : PropTypes.func.isRequired,
	changeResetPasswordConfirmed : PropTypes.func.isRequired,
	dispatch                     : PropTypes.func.isRequired,
	email                        : PropTypes.string,
	loading                      : PropTypes.bool,
	resetPasswordConfirmed       : PropTypes.bool,
	validation                   : PropTypes.string,
};

ResetPassword.defaultProps = {
	email                  : '',
	loading                : false,
	resetPasswordConfirmed : false,
	validation             : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
